import Step from "@frog/source/models/Step.js"

export default function HandleStatusEffects() {
    return (stage) => {
        const steps = []
        Object.values(stage.units).forEach((unit) => {
            if(unit.effects != undefined
            && unit.effects["poisoned"] != undefined) {
                console.log(unit.health, unit.effects["poisoned"].power)
                steps.push(Step.deltastage({
                    "unit": {
                        "key": unit.key,
                        "health": unit.health - (unit.effects["poisoned"].power || 0)
                    }
                }))
            }
        })
        return steps
    }
}
